/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'scuffed',
    quality: 0,
    perception: -2,
    willpower: -2
}